/*
  PrintFinish currency switching.

  Replaces the previous implementation, which did:

      document.cookie = "currency=" + newCurrency + ";path=/";
      location.reload();

  Shopify Markets ignores that cookie completely — it belonged to the old
  client-side converter. Setting it changed nothing, which is why the header
  currency list appeared to do nothing.

  Under Markets, currency is a property of the visitor's market and the market is
  selected by country, so switching currency means POSTing a country_code to
  /localization. The existing .currencies markup in the header keeps working as
  is; only the mechanism underneath it has changed.
*/
(function () {
  'use strict';

  // Currency -> the country whose market uses it. Extend alongside Markets.
  var CURRENCY_TO_COUNTRY = {
    CAD: 'CA',
    USD: 'US',
    EUR: 'DE',
    GBP: 'GB'
  };

  function localizationUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/localization';
  }

  function switchToCountry(countryCode) {
    var form = document.createElement('form');
    form.method = 'post';
    form.action = localizationUrl();
    form.acceptCharset = 'UTF-8';
    form.style.display = 'none';

    // Mirrors exactly what {% form 'localization' %} emits.
    var fields = {
      form_type: 'localization',
      utf8: '✓',
      _method: 'put',
      country_code: countryCode,
      return_to: window.location.pathname + window.location.search
    };

    Object.keys(fields).forEach(function (name) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = fields[name];
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  }

  document.addEventListener('DOMContentLoaded', function () {
    var items = document.querySelectorAll('.currencies li');

    Array.prototype.forEach.call(items, function (li) {
      li.addEventListener('click', function (event) {
        var input = li.querySelector('input.currencies-a');
        var currency = input && input.value;
        if (!currency) return;

        var country = CURRENCY_TO_COUNTRY[currency.toUpperCase()];
        // An unmapped currency is left alone rather than silently mis-switching.
        if (!country) return;

        event.preventDefault();
        switchToCountry(country);
      });
    });
  });
})();
